import Image from 'next/image';
import React, { useContext } from 'react';

import Heading from '@components/Heading';
import Section from '@components/Section';
import { ProductPageContext } from '@contexts/PageContext';
import { loaderProp } from '@utils/random';

const Column = ({ data }) => {
  return (
    <li
      className="rounded-3xl flex flex-col"
      style={{ border: '1px solid #CFD5DB' }}
    >
      <div>
        <Image
          alt={data.image.fields.description}
          src={data.image.fields.file.url}
          height={data.image.fields.file.details.image.height}
          width={data.image.fields.file.details.image.width}
          layout="responsive"
          loader={loaderProp}
          className="rounded-t-3xl"
        />
      </div>
      <div
        className="p-8 font-inter"
        style={{
          borderTop: '0.5px solid rgba(34, 38, 42, 0.3)',
          transform: 'translateY(-1px)',
        }}
      >
        <p className="font-semibold text-lg text-black">{data.title}</p>
        <p className="mt-2 font-medium text-base">{data.description}</p>
      </div>
    </li>
  );
};

const SubfeaturesSection = () => {
  const pageData = useContext(ProductPageContext);
  const {
    ledeText,
    secondSectionHeading,
    secondSectionSubheading,
    secondSectionCards,
  } = pageData;

  return (
    <Section customStyles={{ alignItems: 'flex-start' }}>
      <div className="mb-6 md:mb-20 mx-auto">
        <Heading
          Tag="h2"
          size="lg"
          className={`${
            ledeText === 'Shared queries' ? '' : 'sm:max-w-xl'
          } mt-10 md:mt-20 lg:mt-24 text-center mx-auto`}
        >
          {secondSectionHeading}
        </Heading>
        {secondSectionSubheading && (
          <p className="font-inter font-medium text-xl md:text-2xl mt-4 max-w-2xl text-center">
            {secondSectionSubheading}
          </p>
        )}
      </div>

      <ul
        className={`grid sm:grid-cols-2 ${
          ledeText === 'Version history' || ledeText === 'Query variables'
            ? 'lg:grid-cols-2'
            : 'lg:grid-cols-3'
        } gap-4 sm:gap-8`}
      >
        {secondSectionCards.map((card, i) => (
          <Column data={card} key={i} />
        ))}
      </ul>
    </Section>
  );
};

export default SubfeaturesSection;
